// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Block, { BlockContainer } from "@store/Library/Components/Toolkit/Block/Block";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { checkoutGridProps } from "@store/Themes/common/props/checkout";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const OrderConfirmationHeading = getWidgetComponent("OrderConfirmation/OrderConfirmationHeading");
const OrderConfirmationOrderInformation = getWidgetComponent("OrderConfirmation/OrderConfirmationOrderInformation");
const OrderConfirmationProductList = getWidgetComponent("OrderConfirmation/OrderConfirmationProductList");
const OrderConfirmationTotal = getWidgetComponent("OrderConfirmation/OrderConfirmationTotal");

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCartState(state, state.pages.orderConfirmation.cartId);
    return {
        cartState,
        linkedCartState: cartState.value?.properties.linkedCarts
            ? getCartState(state, cartState.value.properties.linkedCarts)
            : null,
    };
};

export interface SplitOrderConfirmationViewStyles {
    container?: GridContainerProps;
    headerGridItem?: GridItemProps;
    accountSignUpGridItem?: GridItemProps;
    orderInformationGridItem?: GridItemProps;
    orderTotalGridItem?: GridItemProps;
    productListGridItem?: GridItemProps;
    orderTotalDesktopGridItem?: GridItemProps;
    orderTotalMobileGridItem?: GridItemProps;
    orderHeadingGridItem?: GridItemProps;
}

export const splitOrderConfirmationViewStyles: SplitOrderConfirmationViewStyles = {
    container: {
        ...checkoutGridProps.container,
        css: css`
            ${checkoutGridProps.container?.css}

            &:not(:first-child) {
                margin-top: ${pxToRem(60)};
            }
        `,
    },
    orderInformationGridItem: checkoutGridProps.mainColumn,
    orderTotalGridItem: checkoutGridProps.sideColumn,
    orderTotalDesktopGridItem: {
        width: checkoutGridProps.sideColumn?.width,
        printWidth: checkoutGridProps.sideColumn?.printWidth,
        css: css`
            ${breakpoint("sm", "down")} {
                display: none;
            }
        `,
    },
    orderTotalMobileGridItem: {
        width: checkoutGridProps.sideColumn?.width,
        printWidth: checkoutGridProps.sideColumn?.printWidth,
        css: css`
            ${breakpoint("md", "up")} {
                display: none;
            }
        `,
    },
    productListGridItem: {
        ...checkoutGridProps.mainColumn,
        css: css`
            ${BlockContainer} {
                width: 100%;
            }
        `,
    },
    orderHeadingGridItem: {
        ...checkoutGridProps.mainColumn,
        css: css`
            ${checkoutGridProps.mainColumn?.css}
            flex-direction: column
        `,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = splitOrderConfirmationViewStyles;
const SplitOrderConfirmationView = ({ cartState, linkedCartState }: Props) => {
    if (cartState.isLoading || linkedCartState?.isLoading) {
        return (
            <Block>
                <Loader />
            </Block>
        );
    }
    const linkedCart = linkedCartState?.value;
    if (!linkedCart) {
        return null;
    }

    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem {...styles.orderHeadingGridItem}>
                    <OrderConfirmationHeading />
                </GridItem>
                <GridItem {...styles.orderInformationGridItem}>
                    <OrderConfirmationOrderInformation showShippingInformation={false} showOrderNumber={true} />
                </GridItem>
                <GridItem {...styles.productListGridItem}>
                    <OrderConfirmationProductList />
                </GridItem>
                <GridItem {...styles.orderTotalDesktopGridItem}>
                    <OrderConfirmationTotal />
                </GridItem>
            </GridContainer>
            {linkedCart && (
                <GridContainer {...styles.container}>
                    <GridItem {...styles.orderInformationGridItem}>
                        <OrderConfirmationOrderInformation
                            showShippingInformation={false}
                            showOrderNumber={true}
                            useLinkedCart={true}
                        />
                    </GridItem>
                    <GridItem {...styles.productListGridItem}>
                        <OrderConfirmationProductList useLinkedCart={true} />
                    </GridItem>
                    <GridItem {...styles.orderTotalDesktopGridItem}>
                        <OrderConfirmationTotal useLinkedCart={true} />
                    </GridItem>
                    <GridItem {...styles.orderInformationGridItem}>
                        <OrderConfirmationOrderInformation
                            showShippingInformation={true}
                            showOrderNumber={false}
                            showPoNumber={true}
                        />
                    </GridItem>
                </GridContainer>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SplitOrderConfirmationView),
    definition: {
        displayName: "SplitOrderConfirmationView",
        icon: "cart-circle-check",
        group: "Order Confirmation",
    },
};

export default widgetModule;
